export default __webpack_public_path__ + "static/media/studyMaterialImg.86638694.svg";